export default __webpack_public_path__ + "static/media/bookmark.8f5a9504.svg";